<div id="grade-sheet" #gradeSheet>

  @if (document.content?.duplicateCertificateNumber) {
    <section id="duplicate-info">
      <p>{{'certificates.grade_sheet_cert_nr' | translate}} {{document.content?.duplicateCertificateNumber}}</p>
      <p>{{'certificates.grade_sheet_duplicate' | translate}} {{document.content?.duplicateIssueDate }}</p>
    </section>
  }

  <section id="header">
    <h1 id="grade-sheet-title">{{ document.content?.documentName?.toUpperCase() }}</h1>
    <p id="for-certificate">{{ ('certificates.grade_sheet_for_certificate' | translate).replace('%number%', document.content?.registrationNumber) }}</p>
    <p>
      @if (document.content?.graduate?.idCode) {
        {{'certificates.grade_sheet_id_code' | translate}}
      }
      @if (!document.content?.graduate?.idCode && document.content?.graduate?.dateOfBirth) {
        {{'certificates.grade_sheet_date_of_birth' | translate}}
      }
      <span class="bold">
        {{ (document.content?.graduate?.idCode | idCode) || document.content?.graduate?.dateOfBirth || '' }}
      </span>
    </p>
  </section>

  <section id="info">
    @if (document.status === 'CERT_DOCUMENT_STATUS:INVALID') {
      <p class="info-badge">{{'certificates.grade_sheet_invalid' | translate}}</p>
    }
    <p class="bold">{{ document.content?.graduate?.firstName }} {{ document.content?.graduate?.lastName }}</p>
    <p [class.bold]="toimetulekuOpe">{{'certificates.grade_sheet_studied' | translate}} <span class="bold">{{ document.content?.studies?.curriculumNameToPrintOut }}.</span></p>
    <p>{{'certificates.grade_sheet_study_language' | translate}}: {{ document.content?.studies?.language }}</p>
  </section>

  <p class="bold">{{'certificates.grade_sheet_grades' | translate}}:</p>

  <section id="grades">
    @if (toimetulekuOpe) {
      <p class="subject-type">{{'certificates.grade_sheet_compulsory_subjects' | translate}}:</p>
      @for (subject of mandatorySubjects; track subject) {
        <div class="subject-grade">
          <p class="bold">
            {{subject?.subject}}
          </p>
          <p>
            {{subject?.resultInWords}}
          </p>
        </div>
      }
      @if (electives?.length > 0) {
        <p class="subject-type">{{'certificates.grade_sheet_elective_subjects' | translate}}:</p>
      }
      @for (subject of electives; track subject) {
        <div class="subject-grade">
          <p class="bold">
            {{subject?.subject}}
          </p>
          <p>
            {{subject?.resultInWords}}
          </p>
        </div>
      }
    } @else {
      <scrollableContent>
        <table>
          <tbody>
            <tr class="highlight">
              <td>{{'certificates.grade_sheet_compulsory_subjects' | translate}}</td>
              @if (isGeneralEducation) {
                <td>{{'certificates.grade_sheet_courses' | translate}}</td>
              }
              @if (!isGeneralEducation && hasGradedExaminations && hasResultantExaminations) {
                <td></td>
              }
              <td>{{'certificates.grade_sheet_grade' | translate}}</td>
            </tr>
            @for (subject of mandatorySubjects; track subject; let last = $last) {
              <tr [class.last-cell]="last && !document.content?.graduationStudy">
                <td>
                  {{subject.subject}}
                  @if (subject.subjectDetail) {
                    ({{subject.subjectDetail}})
                  }
                  @if (subject.studyProgrammeType === 'individuaalne õppekava') {
                    *
                  }
                </td>
                @if (isGeneralEducation) {
                  <td>
                    {{subject.amount}}
                  </td>
                }
                @if (!isGeneralEducation && hasGradedExaminations && hasResultantExaminations) {
                  <td></td>
                }
                <td>
                  @if (subject.resultNumeric != null) {
                    <span class="numeric-grade">{{subject.resultNumeric}}</span>
                    }{{subject.resultInWords}}
                    @if (!subject.resultNumeric && !subject.resultInWords && subject.studyProgrammeType !== 'individuaalne õppekava') {
                      {{subject.studyProgrammeType}}
                    }
                  </td>
                </tr>
              }
              @if (document?.content?.graduationStudy) {
                <tr class="last-cell">
                  <td [attr.colspan]="isGeneralEducation || (!isGeneralEducation && hasGradedExaminations && hasResultantExaminations) ? 2 : null">
                    {{ document.content.graduationStudy.type }}: {{ document.content.graduationStudy.subject }}
                  </td>
                  <td>
                    @if (document.content.graduationStudy.resultNumeric != null) {
                      <span class="numeric-grade">
                        {{document.content.graduationStudy.resultNumeric}}
                      </span>
                    }
                    {{document.content.graduationStudy.resultInWords}}
                  </td>
                </tr>
              }
              @if (electives?.length > 0) {
                <tr class="highlight">
                  <td>{{'certificates.grade_sheet_elective_subjects' | translate}}</td>
                  @if (isGeneralEducation) {
                    <td>{{'certificates.grade_sheet_courses' | translate}}</td>
                  }
                  @if (!isGeneralEducation && hasGradedExaminations && hasResultantExaminations) {
                    <td></td>
                  }
                  <td>{{'certificates.grade_sheet_grade' | translate}}</td>
                </tr>
              }
              @for (subject of electives; track subject; let last = $last) {
                <tr [class.last-cell]="last">
                  <td>
                    {{subject.subject}}
                    @if (subject.subjectDetail) {
                      ({{subject.subjectDetail}})
                    }
                    @if (subject.studyProgrammeType === 'individuaalne õppekava') {
                      *
                    }
                  </td>
                  @if (isGeneralEducation) {
                    <td>
                      {{subject.amount}}
                    </td>
                  }
                  @if (!isGeneralEducation && hasGradedExaminations && hasResultantExaminations) {
                    <td></td>
                  }
                  <td>
                    @if (subject.resultNumeric != null) {
                      <span class="numeric-grade">{{subject.resultNumeric}}</span>
                      }{{subject.resultInWords}}
                      @if (!subject.resultNumeric && !subject.resultInWords && subject.studyProgrammeType !== 'individuaalne õppekava') {
                        {{subject.studyProgrammeType}}
                      }
                    </td>
                  </tr>
                }
                @if (document?.content?.graduationExaminations?.length) {
                  <tr class="highlight">
                    <td [attr.colspan]="resultColspan">{{'certificates.grade_sheet_final_exams' | translate}}</td>
                    @if (hasResultantExaminations || !hasGradedExaminations) {
                      <td>{{'certificates.grade_sheet_result' | translate}}</td>
                    }
                    @if (hasGradedExaminations) {
                      <td>{{'certificates.grade_sheet_grade' | translate}}</td>
                    }
                  </tr>
                  @for (subject of document?.content?.graduationExaminations; track subject; let last = $last) {
                    <tr [class.last-cell]="last">
                      <td [attr.colspan]="resultColspan">
                        {{subject.subject}}
                        @if (subject.type === 'koolieksam') {
                          *
                        }
                      </td>
                      @if (hasResultantExaminations || !hasGradedExaminations) {
                        <td>
                          @if (subject.resultPercent) {
                            <span>{{subject.resultPercent}}%</span>
                          }
                        </td>
                      }
                      @if (hasGradedExaminations) {
                        <td>
                          @if (subject.resultNumeric != null) {
                            <span class="numeric-grade">{{subject.resultNumeric}}</span>
                            }{{subject.resultInWords}}
                          </td>
                        }
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </scrollableContent>
          }

        </section>

        @if (hasIndividualProgramme || hasSchoolExam) {
          <section class="additional-info">
            @if (hasIndividualProgramme) {
              <p>{{'certificates.grade_sheet_individual_programme_explanation' | translate}}</p>
            }
            @if (hasSchoolExam) {
              <p>{{'certificates.grade_sheet_school_exam_explanation' | translate}}</p>
            }
          </section>
        }

        @if (document.content?.conductGrade?.resultInWords) {
          <section class="additional-info">
            <p>{{'certificates.grade_sheet_conduct' | translate}} {{ document.content?.conductGrade?.resultInWords }}</p>
          </section>
        }

        <section class="additional-info">
          <p>{{'certificates.grade_sheet_printed_by' | translate}} <span class="bold">{{ document.content?.issuer?.nameToPrintOut }}</span></p>
          <p>{{ ('certificates.grade_sheet_printed_at' | translate).replace('%date', document.content?.councilDecision?.issueDateToPrintOut) }}</p>
        </section>

        @if (toimetulekuOpe) {
          <section class="additional-info">
            <p>{{'certificates.grade_sheet_valid_with_primary_school' | translate}}</p>
          </section>
        }

        <section class="additional-info">
          <p>{{ document.content?.qualificationToPrintOut }}</p>
        </section>

        @if (document.number) {
          <section id="grade-sheet-number">
            <p>{{ document.number }}</p>
          </section>
        }
      </div>
